import { useEffect, useRef } from 'react';

const steps = [
  {
    number: '01',
    title: 'Seleção de Ingredientes',
    desc: 'Ingredientes frescos e selecionados de fornecedores certificados. Priorizamos qualidade e origem.',
    icon: 'ri-leaf-line',
  },
  {
    number: '02',
    title: 'Produção Artesanal',
    desc: 'Preparação cuidadosa em ambiente controlado, seguindo rigorosos padrões de higiene.',
    icon: 'ri-restaurant-line',
  },
  {
    number: '03',
    title: 'Controle de Qualidade',
    desc: 'Inspeção visual, checagem de temperatura e validade antes de cada embalagem.',
    icon: 'ri-shield-check-line',
  },
  {
    number: '04',
    title: 'Distribuição Rápida',
    desc: 'Transporte refrigerado direto para seu estabelecimento, garantindo frescor e segurança.',
    icon: 'ri-truck-line',
  },
  {
    number: '05',
    title: 'Na Sua Rotina',
    desc: 'Pronto para acompanhar o seu dia. Prático, nutritivo e feito com dedicação.',
    icon: 'ri-heart-3-line',
  },
];

const QualityTimeline = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="qualidade" ref={sectionRef} className="relative bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-7xl">
          {/* Header */}
          <div className="mb-16 text-center md:mb-20">
            <span className="reveal mb-4 inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.3em] text-secondary-500 md:text-sm">
              <span className="h-px w-8 bg-secondary-500/60" />
              Nosso Processo
              <span className="h-px w-8 bg-secondary-500/60" />
            </span>
            <h2 className="reveal reveal-delay-1 mb-4 font-display text-3xl leading-tight text-foreground-950 md:text-5xl">
              Nosso <span className="italic text-accent-400">cuidado</span> em cada etapa
            </h2>
            <p className="reveal reveal-delay-2 mx-auto max-w-2xl font-body text-base leading-relaxed text-foreground-500 md:text-lg">
              Cada etapa do caminho tem um propósito: preservar o sabor, o frescor e a segurança que você encontra na hora da refeição.
            </p>
          </div>

          {/* Timeline */}
          <div className="relative">
            {/* Desktop connector line */}
            <div className="absolute left-[10%] right-[10%] top-[52px] hidden h-px bg-gradient-to-r from-transparent via-secondary-500/40 to-transparent lg:block" />

            <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-12 lg:grid-cols-5 lg:gap-8">
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  className="reveal group relative flex flex-col items-center text-center"
                  style={{ transitionDelay: `${index * 0.15}s` }}
                >
                  {/* Icon bubble */}
                  <div className="relative z-10 mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-full border border-secondary-500/40 bg-background-50 transition-colors duration-500 group-hover:border-secondary-500">
                    <i className={`${step.icon} text-lg text-secondary-500`} />
                  </div>

                  {/* Serif number */}
                  <div className="mb-3 select-none font-display text-4xl leading-none text-secondary-500/60 md:text-5xl">
                    {step.number}
                  </div>

                  <h3 className="mb-2 font-heading text-base font-semibold text-foreground-900 md:text-lg">
                    {step.title}
                  </h3>
                  <p className="font-body text-sm leading-relaxed text-foreground-500">
                    {step.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualityTimeline;